import { FilterOptionKeys, GoalFilterDocument } from '@griply/types';
import {
  defaultGoalsOverviewFilterDocument,
  goalAndProjectFilterSections,
  GoalListFilterKey,
} from '@griply/utils';
import { useUpdateGoal } from 'features/goals';
import React, { useMemo } from 'react';
import { GoalListFilterButton } from 'shared/components/connected/goal-list-filter-button';
import { Colors } from 'shared/components/ui/icon-button';
import { Goal } from 'shared/types/goal';

// no LifeArea (sub-goals carry none); no GoalType (hiding Goals would orphan their nested Projects)
const supportedFilters: GoalListFilterKey[] = [
  FilterOptionKeys.Date,
  FilterOptionKeys.Deadline,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
];
const noGroupByModes: never[] = [];
const noSortingModes: never[] = [];

export type RoadmapFilterButtonProps = {
  goal: Goal;
};

export const RoadmapFilterButton: React.FC<RoadmapFilterButtonProps> = ({
  goal,
}) => {
  const { submit: updateGoal } = useUpdateGoal();

  // raw stored doc as write base — merged defaults would persist a sortingMode and break the goalSortingMode fallback
  const filterDocument = useMemo(
    () => goal.goalFilterDocument ?? {},
    [goal.goalFilterDocument],
  );

  const updateFilterDocument = (document: Partial<GoalFilterDocument>) =>
    updateGoal({ id: goal.id, goalFilterDocument: document });

  const onReset = () =>
    updateGoal({
      id: goal.id,
      goalFilterDocument: {
        ...(goal.goalFilterDocument ?? {}),
        filters: null,
      },
    });

  // the goal-active info link is hidden here
  const filterInfoUrlOverrides = useMemo(
    () => ({ [FilterOptionKeys.GoalActive]: null }),
    [],
  );

  return (
    <GoalListFilterButton
      filterDocument={filterDocument}
      defaultFilterDocument={defaultGoalsOverviewFilterDocument}
      supportedGroupByModes={noGroupByModes}
      supportedSortingModes={noSortingModes}
      supportedFilters={supportedFilters}
      filterInfoUrlOverrides={filterInfoUrlOverrides}
      filterSections={goalAndProjectFilterSections}
      iconColor={Colors.Default}
      onUpdate={updateFilterDocument}
      onReset={onReset}
    />
  );
};
